import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4 is-flex is-align-items-center is-justify-content-space-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "title is-size-4 mb-0" }, " Hierarchies ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "panel"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "is-flex-grow-1 is-flex is-justify-content-space-between" }
const _hoisted_7 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_8 = { class: "has-text-weight-bold" }
const _hoisted_9 = {
  key: 1,
  class: "has-text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page_content = _resolveComponent("page-content")!

  return (_openBlock(), _createBlock(_component_page_content, { class: "container-narrow" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.collection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_hydra_operation_button, {
                operation: _ctx.collection.actions.create,
                to: { name: 'HierarchyCreate' },
                variant: "default",
                size: "normal",
                label: _ctx.collection.actions.create.title
              }, null, 8, ["operation", "label"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.collection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.collection.member.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collection.member, (hierarchy) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: hierarchy.id.value,
                      to: { name: 'Hierarchy', params: { id: hierarchy.clientPath } },
                      class: "panel-block"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(hierarchy.getString('http://schema.org/name')), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, " No shared dimension yet "))
          ]))
        : (_openBlock(), _createBlock(_component_loading_block, { key: 1 })),
      (_ctx.collection)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}